import * as React from 'react';
import { Config } from '../../helper';
import CardSearchResult from './CardSearchResult';
import AccordionSearchResult from './AccordionSearchResult';
import ProfileTeaserSearchResult from './ProfileTeaserSearchResult';
import { TableSearchResult } from './table';

export default function SearchResult({viewMode}) {
  if (!viewMode) return null;

  if (viewMode.viewMode === Config.ViewModes.Accordion) {
    return <AccordionSearchResult displayOptions={viewMode}/>;
  }

  if (viewMode.viewMode === Config.ViewModes.ProfileTeaser) {
    return <ProfileTeaserSearchResult displayOptions={viewMode}/>;
  }

  if (viewMode.viewMode === Config.ViewModes.Table) {
    return <TableSearchResult displayOptions={viewMode}/>;
  }

  return <CardSearchResult displayOptions={viewMode}/>;
}
